const configUrl={
    data(){
       return{
        ossUrl:'http://txm.oss-cn-beijing.aliyuncs.com/TXM_static_material_img_'
       }
    }
}
export default configUrl